export { default } from './Atlantm30';
